module.exports = __webpack_public_path__ + "img/training.cc30cc9a.svg";